import React from 'react'
import CardSrc from '@/images/promos/card.jpg'

const CreditCardContent = {
  gaAction: '',
  headingText: (
    <>
      Maximize your savings with applying for the Priceline Rewards<sup>™</sup>{' '}
      Visa<sup>®</sup> Card!
    </>
  ),
  contentText: (
    <ul>
      <li>
        Looking to fast-track your VIP status? Automatically become VIP Gold
        once approved.
      </li>
      <li>
        Earn 5X Points on eligible hotel, flight, package, rental car and cruise
        purchases using your card.*
      </li>
      <li>Plus, get special cardmember coupons, discounts & perks!</li>
    </ul>
  ),
  image: `${CardSrc}?opto=true&auto=webp`,
  alt: '',
  buttons: [
    {
      gaLabel: '',
      buttonText: 'Learn More',
      linkUrl:
        'https://www.pricelinevisa.com/apply/Landing.action?campaignId=2566&cellNumber=6&referrerid=HOMEPAGE'
    }
  ]
}

export default CreditCardContent
